<template>
    <div>
        <v-card>
            <v-alert
                :value="true"
                type="info"
            >
                The <b>Audit Log</b> was updated in October 2025 to include the IP address and user agent of the user accessing the object. Audit log entries created prior to this update will not have this information. To obtain the user agent, please contact support.
            </v-alert>
            <v-data-table
                :items="data"
                :headers="headers"
                :pagination.sync="pagination"
                :total-items="totalAudit"
                :rows-per-page-items="paginationStrings"
                :loading="loading"
                disable-initial-sort
            >
                <template slot="items" slot-scope="props">
                    <tr
                        :key="props.item.id"
                    >
                        <td>
                            <b>Date/Time:</b> {{ convertToLocal(props.item.accessed_at) }}
                            <span
                                v-if="props.item.ip_addr"
                            >
                                <br/><b>IP Address:</b>&nbsp;<span style="font-family:monospace;display:inline;">{{ props.item.ip_addr }}</span>
                            </span>
                        </td>
                        <td>
                            {{ getObjectType(props.item.type) }}
                        </td>
                        <td>
                            <ContactPreview 
                                v-if="props.item.type === 'contact' "
                                :contact="props.item.data"
                            />
                            <CasePreview
                                v-else-if="props.item.type === 'case'"
                                :xcase="props.item.data"
                            />
                            <UserFormPreview
                                v-else-if="props.item.type === 'user form'"
                                :userform="props.item.data"
                            />
                            <ContactFilePreview
                                v-else-if="props.item.type === 'contact file upload'"
                                :contactFile="props.item.data"
                            />
                            <ReportPreview
                                v-else-if="props.item.type.includes('report')"
                                :report="props.item.data"
                            />
                            <FileAnswerPreview
                                v-else-if="props.item.type === 'file answer'"
                                :fileAnswer="props.item.data"
                            />
                            <div
                                v-else
                            >
                                {{ props.item.data }}
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import api from '@/api'
import CasePreview from '../cases/CasePreview.vue'
import ContactFilePreview from '../contacts/ContactFilePreview.vue'
import ContactPreview from '../contacts/ContactPreview.vue'
import ReportPreview from '../reports/ReportPreview.vue'
import FileAnswerPreview from '../userform/FileAnswerPreview.vue'
import UserFormPreview from '../userform/UserFormPreview.vue'
import pagination from '@/components/global/pagination'

export default {
    name: 'UserActivityLog',
    props: ['user'],
    components: {
        ContactPreview,
        CasePreview,
        UserFormPreview,
        ContactFilePreview,
        ReportPreview,
        FileAnswerPreview
    },
    mixins: [
        pagination
    ],
    data () {
        return {
            data: [],
            headers: [
                { text: 'Access Details', width: '25%', value: 'accessed_at'},
                { text: 'Type of Object', width: '25%', value: 'model', sortable: false},
                { text: 'Object Accessed', value: 'object_id', sortable: false}
            ],
            pagination: {
                rowsPerPage: 25
            },
            loading: true,
            routing: false,
            paginationStrings: [
                25, 50
            ],
        }
    },
    computed: {
        totalAudit () {
            return this.pagination.totalItems
        }
    },
    methods: {
        fetch(){
            this.loading = true
            api.users.audit.list({
                ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, pageNum: this.pagination.page, count: this.pagination.rowsPerPage, filter: {"user": this.user}
            })
            .then((data) => {
                this.data = data.results
                this.pagination.page = data.page_number
                this.pagination.totalItems = data.count
                this.loading = false
                this.componentCreated = true
            })
        },
        getObjectType(type){
            switch(type) {
                case 'contact':
                    return "Contact"
                case 'case':
                    return "Case"
                case 'user form':
                    return "Form"
                case 'contact file upload':
                    return "Contact File Upload"
                case 'form report':
                case 'form file report':
                case 'contact file report':
                    return "Report Download"
                case 'file answer':
                    return "Form File Answer"
                default:
                    return type
            }
        }
    }
}

</script>